<template>
	<div>
		<h1 class="title">{{ equipo.nombre ? equipo.nombre:'Nuevo Equipo' }}</h1>
		<form action="" @submit.prevent="saveEquipo">
			<div class="field">
				<label class="label">Nombre</label>
				<div class="control">
					<input class="input" type="text" placeholder="Nombre del Equipo.." v-model="equipo.nombre"/>
				</div>
				<p class="help">Nombre del Equipo</p>
			</div>
			
			<div class="field">
				<label for="" class="label">Liga</label>
				<div class="control">
					<div class="select">
						<select name="" id="" v-model="equipo.id_liga">
							<option disabled selected value="">Select Liga</option>
							<option :value="liga.id" v-for="liga in ligas" :key="liga.id">{{ liga.nombre }}</option>
						</select>
					</div>
				</div>
				<p class="help">Liga a la que pertenece el equipo</p>
			</div>

			<div class="field">
				<label class="label">Noticias</label>
				<div class="control">
					<input class="input" type="text" placeholder="Noticias del Equipo.." v-model="equipo.noticias"/>
				</div>
				<p class="help">URL de noticias del Equipo</p>
			</div>

			<div class="field is-grouped" style="align-items: flex-end;">
				<div class="control" v-if="equipo.logo_big">
					<label for="" class="label">Logo</label>
					<figure class="image is-64x64">
						<img :src="equipo.logo_big" alt="">
					</figure>
				</div>

				<div class="control">
					<div class="file has-name is-boxed is-small">
						<label class="file-label">
							<input type="file" class="file-input" @change="fileSelected($event)" name="logo">
							<span class="file-cta">
								<span class="file-icon">
									<font-awesome-icon icon="image" />
								</span>
								<span class="file-label">{{ equipo.logo_big ? 'Cambiar logo...':'Seleccionar logo...' }}</span>
							</span>
							<span class="file-name" ref="logoField"></span>
						</label>
					</div>
				</div>
			</div>
			
			<div class="buttons">
				<button class="button is-info" type="submit">Guardar</button>	
				<button class="button" @click.prevent="goBack">Cancelar</button>
			</div>
		</form>
	</div>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		data() {
			return {
				
			};
		},
		created(){
			if (this.$route.params.id != undefined && this.$route.params.id != 'new') {
				this.$store.dispatch('equipos/fetchEquipo', this.$route.params.id)
			}else{
				this.clearForm()
			}
			this.$store.dispatch('ligas/fetchLigas');
		},
		computed: {
			...mapState('ligas',['ligas']),
			...mapState('equipos',['equipo'])
		},
		methods:{
			saveEquipo(){
				this.$store.dispatch('equipos/saveEquipo',this.equipo)
				.then(() => {
					this.goBack()
				})
			},
			goBack(){
				this.$router.push({ name: "Equipos" });
			},
			clearForm() {
				this.$store.commit("equipos/SET_EQUIPO", {});
			},
			fileSelected(event){
				let file2Read = event.target.files[0]
				this.$refs.logoField.textContent = file2Read.name
				this.$set(this.equipo,'logo',file2Read)
			}
		}
};
</script>
